
  import { Vue, Component, Prop } from "vue-property-decorator";
  import getFullName from "@/helpers/getFullName";
  import getInitials from "@/helpers/getInitials";

  @Component
  export default class EmployeeDataProvider extends Vue {
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;

    get fullName(): string {
      return getFullName(this.givenName, this.familyName);
    }

    get initials(): string {
      return getInitials(this.givenName, this.familyName);
    }
  }
